/* global axios */
import ApiClient from './ApiClient';

class CampaignAliasesAPI extends ApiClient {
  constructor() {
    super('campaign_aliases', { accountScoped: true });
  }

  getTargets() {
    return axios.get(`${this.url}/targets`);
  }
}

export default new CampaignAliasesAPI();
